import TableView, { TableSection } from '@/components/TableView'
import useCopyText from '@/components/useCopyText'
import { useNetInfo } from '@react-native-community/netinfo'
import Constants from 'expo-constants'
import * as Device from 'expo-device'
import { Platform } from 'react-native'

type DiagnosticsProps = {
  userId?: string
  teamId?: string
}

function getNetworkTypeText(type: string | null): string {
  if (!type) return '未知'
  switch (type) {
    case 'wifi':
      return 'WiFi'
    case 'cellular':
      return '蜂窝网络'
    case 'none':
      return '离线'
    case 'unknown':
      return '未知'
    case 'bluetooth':
      return '蓝牙'
    case 'ethernet':
      return '以太网'
    case 'wimax':
      return 'WiMAX'
    case 'vpn':
      return 'VPN'
    case 'other':
      return '其他'
    default:
      return type
  }
}

function getConnectionStatusText(isConnected: boolean | null): string {
  if (isConnected === null) return '检测中...'
  return isConnected ? '已连接' : '未连接'
}

export default function Diagnostics({ userId, teamId }: DiagnosticsProps) {
  const copyText = useCopyText()
  const netInfo = useNetInfo()

  const appVersion = Constants.expoConfig?.version ?? '未知'
  const buildNumber =
    Platform.OS === 'ios'
      ? Constants.expoConfig?.ios?.buildNumber
      : Constants.expoConfig?.android?.versionCode?.toString()

  const deviceInfo = {
    os: Platform.OS === 'ios' ? 'iOS' : 'Android',
    osVersion: Device.osVersion ?? '未知',
    modelName: Device.modelName ?? '未知',
  }

  const handleCopyAll = () => {
    const lines = [
      '诊断信息',
      '',
      '设备信息',
      `操作系统: ${deviceInfo.os}`,
      `系统版本: ${deviceInfo.osVersion}`,
      `设备型号: ${deviceInfo.modelName}`,
      '',
      '应用信息',
      `App 版本: ${appVersion}`,
      `构建号: ${buildNumber ?? '未知'}`,
      '',
      '网络信息',
      `网络类型: ${getNetworkTypeText(netInfo.type)}`,
      `连接状态: ${getConnectionStatusText(netInfo.isConnected)}`,
      '',
      '用户信息',
      `用户 ID: ${userId ?? '未登录'}`,
      `团队 ID: ${teamId ?? '未登录'}`,
    ]

    copyText(lines.join('\n'))
  }

  const sections: TableSection[] = [
    {
      title: '设备信息',
      rows: [
        { title: '操作系统', detailText: deviceInfo.os },
        { title: '系统版本', detailText: deviceInfo.osVersion },
        { title: '设备型号', detailText: deviceInfo.modelName },
      ],
    },
    {
      title: '应用信息',
      rows: [
        { title: 'App 版本', detailText: appVersion },
        { title: '构建号', detailText: buildNumber ?? '未知' },
      ],
    },
    {
      title: '网络信息',
      rows: [
        { title: '网络类型', detailText: getNetworkTypeText(netInfo.type) },
        { title: '连接状态', detailText: getConnectionStatusText(netInfo.isConnected) },
      ],
    },
    {
      title: '用户信息',
      rows: [
        { title: '用户 ID', detailText: userId ?? '未登录' },
        { title: '团队 ID', detailText: teamId ?? '未登录' },
      ],
    },
    {
      title: '',
      rows: [{ title: '复制全部信息', type: 'action', onPress: handleCopyAll }],
    },
  ]

  return <TableView sections={sections} />
}
